import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { MonacoEditor } from '@/components/editor/MonacoEditor';
import { useToast } from '@/hooks/use-toast';

interface ValidationError {
  line: number;
  column?: number;
  message: string;
  severity?: string;
  source?: string;
}

interface PlaygroundEditorProps {
  content: string;
  onChange: (value: string) => void;
  validationErrors?: ValidationError[];
  readOnly?: boolean;
}

export function PlaygroundEditor({
  content,
  onChange,
  validationErrors = [],
  readOnly = false,
}: PlaygroundEditorProps) {
  const navigate = useNavigate();
  const { toast } = useToast();

  // Handle reference clicks - open in Editor page
  const handleOpenReference = useCallback(async (itemId: string) => {
    // Navigate to Editor page with the item
    navigate(`/editor?item=${itemId}`);
    toast({
      title: 'Opening in Editor',
      description: 'Reference opened in the Content Editor',
    });
  }, [navigate, toast]);

  return (
    <div className="h-full w-full rounded-lg overflow-hidden border">
      <MonacoEditor
        value={content}
        onChange={onChange}
        validationErrors={validationErrors}
        contentType="agent"
        onOpenReference={handleOpenReference}
      />
    </div>
  );
}

export default PlaygroundEditor;
